import { webApiService } from '@/services'
import { blobToBase64 } from '@/utils/blobToBase64.util'
import { Card, CardContent, Grid, ImageList, ImageListItem, Typography } from '@mui/material'
import { Button } from '@nextui-org/react'
import { fromImage } from 'imtool'
import { enqueueSnackbar } from 'notistack'
import React, { useEffect, useRef, useState } from 'react'
// import { Accept, useDropzone } from 'react-dropzone'
import { useParams } from 'react-router-dom'
import { useTradeinContext } from '../hooks/useTradeinContext'
import { IConfigSeller } from '@/models/configSeller'
import { useSelector } from 'react-redux'
import NUIAlert from '@/components/Alert/Alert'
import { IAppStore } from '@/models/store.model'

const Multimedia: React.FC = () => {
  const { ctx, saveCtx } = useTradeinContext()
  const { slug, id } = useParams()
  const userState = useSelector((store: IAppStore) => store.user)
  const fileInputRef = useRef<HTMLInputElement>(null)
  const [data, setData] = useState<{ loading: boolean, imagenes: any[] }>({ loading: false, imagenes: [] })
  const configSeller = useSelector((store: { config: IConfigSeller }) => store.config)
  const isSamsungPeru = configSeller.config.s3.FOLDER_APP === 'ti_samsung_pe'
  const isFalabellaChile = configSeller.config.s3.FOLDER_APP === 'ti_falabella'
  const isMacstoreMexico = configSeller.config.s3.FOLDER_APP === 'ti_macstore'
  const isSamsungMexico = configSeller.config.s3.FOLDER_APP === 'ti_samsung_mx'
  const isHuaweiMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_mx'
  const isTelcelMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_mx'
  const isTelcelCorpMexico = configSeller.config.s3.FOLDER_APP === 'ti_telcel_corp_mx'
  const isHuaweiPeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_pe'
  const isHuaweiChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_cl'
  const isHuaweiOnlineChile = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_cl'
  const isHuaweiOnlineMexico = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_mx'
  const isHuaweiOnlinePeru = configSeller.config.s3.FOLDER_APP === 'ti_huawei_online_pe'
  const isParisChile = configSeller.config.s3.FOLDER_APP === 'ti_paris'
  const isRipleyChile = configSeller.config.s3.FOLDER_APP === 'ti_ripley_cl'
  const isXiaomiMexico = configSeller.config.s3.FOLDER_APP === 'ti_xiaomi'
  const isOppoMexico = configSeller.config.s3.FOLDER_APP === 'ti_oppo'
  const isElektraMexico = configSeller.config.s3.FOLDER_APP === 'ti_elektra_mx'
  const isCoppelMexico = configSeller.config.s3.FOLDER_APP === 'ti_coppel'
  // const isNovabench = import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== '' && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST !== undefined && import.meta.env.VITE_ID_STORE_REMOVECHECKLIST.split(',').includes(String(userState.id_store)) && isFalabellaChile && ctx.tradein.sbu === 'Notebook'
  const isNovabench = (isMacstoreMexico || isFalabellaChile || isRipleyChile) && ctx.tradein.sbu === 'Notebook'
  const hasIAEvaluation = configSeller.config.permisos.ENABLE_IAEVALUATION === 1 && configSeller.config.permisos.SBUS_IA_EVALUATION.includes(ctx.tradein.id_sbu)
  const hasPhonecheck = ctx.tradein.id_sbu === 1 || (ctx.tradein.id_sbu === 3 && ctx.tradein.brand === 'Apple')

  const texto = hasIAEvaluation ? 'Se deben cargar 2 imagenes' : (isFalabellaChile && !hasPhonecheck) ? 'Se deben 4 fotos  que acrediten la declaración de estado estéticos del dispositivo' : 'Se deben cargar al menos 6 fotos. 4  que acrediten la declaración de estado estéticos del dispositivo y 2'
  // console.log('configSeller.config.s3.FOLDER_APP => ', configSeller.config.s3.FOLDER_APP)

  const handleFileChange = async (event: React.ChangeEvent<HTMLInputElement>) => {
    const files = event.target.files
    if (!files || files.length === 0) return

    const imageCompression = (await import('browser-image-compression')).default
    const compressedFiles = await Promise.all(
      Array.from(files).map(async (file) => {
        if (!['image/png', 'image/jpg', 'image/jpeg'].includes(file.type)) return null
        try {
          const compressed = await imageCompression(file, {
            maxSizeMB: 0.8,
            maxWidthOrHeight: 800,
            useWebWorker: true
          });

          (compressed && typeof compressed === 'object') && ((compressed as any).path = compressed.name)
          return compressed
        } catch (err) {
          console.error('Error al comprimir imagen:', err)
          return file
        }
      })
    )
    saveCtx({
      ...ctx,
      files: [...ctx.files, ...compressedFiles.filter(Boolean)]
    })
  }

  const removeFile = (file: File, event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()
    saveCtx({
      ...ctx,
      files: ctx.files.filter(f => f !== file)
    })
  }

  const uploadFiles = async () => {
    const numeroImagenes = hasIAEvaluation ? 2 : (isFalabellaChile && !hasPhonecheck) ? 4 : 6

    if (ctx.files.length < numeroImagenes) {
      enqueueSnackbar('Se deben cargar al menos ' + numeroImagenes + ' imágenes', { variant: 'error' })
      return
    }

    for (const element of ctx.files) {
      if (element.nameFile === undefined) {
        console.log('entro', ctx)
        delete element.preview
        element.blob = await fromImage(element).then((tool: any) => tool.thumbnail(800, false).toBlob())
        element.base64 = await blobToBase64(element.blob)
        delete element.blob
      }
    }
    console.log('🚀 ~ forawait ~ ctx.files:', ctx.files)
    setData({ ...data, loading: true })
    webApiService.saveFiles({ id, files: ctx.files, seller: slug, battery: false, extraControl: false }).then(() => {
      enqueueSnackbar('Imagenes cargadas con exito', { variant: 'success' })
      loadData()
      saveCtx({ ...ctx, files: [], reload: true })
      setData({ ...data, loading: false })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  const loadData = () => {
    setData({ ...data, loading: true })
    webApiService.getFiles(String(id)).then((res: any) => {
      setData({ loading: false, imagenes: res.data.filter((item: any) => !item.name.includes('batteryHealth') && !item.name.includes('extraControl') && !item.name.includes('osiptel')) })
    }).catch((error) => {
      enqueueSnackbar(error.message, { variant: 'error' })
      console.log('error ==>', error)
      setData({ ...data, loading: false })
    })
  }

  useEffect(() => {
    loadData()
    // Cleanup URLs
    return () => {
      ctx.files.forEach(file => {
        URL.revokeObjectURL(URL.createObjectURL(file))
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ctx.files])

  return (
    <Card>
      <CardContent>
        <div className='container'>
          <div className='grid grid-cols-12 mb-2' style={{ borderBottom: '1px solid #f3f1f1' }}>
            <div className='col-span-9'>
              <Typography variant='h6' component='div' gutterBottom style={{ fontSize: '18px' }}>
                Imágenes del dispositivo
              </Typography>
            </div>
            <div
              className='col-span-3 text-end pb-2' hidden={
              (!isSamsungPeru && !isParisChile && (((ctx.tradein.isBatteryHealthy === null && ctx.tradein.isExtraControl === null) && !isNovabench && configSeller.config.permisos.ENABLE_CHECK_BATTERY === 1 && ((isSamsungMexico || isHuaweiMexico || isHuaweiPeru || isHuaweiChile || isTelcelMexico || isTelcelCorpMexico || isHuaweiOnlineChile || isHuaweiOnlineMexico || isHuaweiOnlinePeru || isXiaomiMexico || isOppoMexico || isElektraMexico || isCoppelMexico) && ctx.tradein.sbu !== 'Smartwatch')) || ctx.tradein.url_contract === null || ctx.tradein.id_status !== 3)) ||
              (isSamsungPeru && ((ctx.tradein.isBatteryHealthy === null && ctx.tradein.isExtraControl === null) || ![4, 11].includes(ctx.tradein.id_status)))
              }
            >
              {
                userState.id_role !== Number(import.meta.env.VITE_PERFIL_SOLOLECTURA)
                  ? (
                    <Button isLoading={data.loading} size='sm' color='primary' onClick={() => uploadFiles()}>
                      Cargar imágenes
                    </Button>)
                  : null
              }

            </div>
          </div>
          <NUIAlert type='warning'>{texto} {!isMacstoreMexico && !isFalabellaChile ? 'del carnet de identidad' : (isFalabellaChile && !hasPhonecheck) ? '' : 'de la identificación oficial'}{!isFalabellaChile ? ' del cliente por ambos lados.' : ''}</NUIAlert>

        </div>
        <div className='container'>
          <div className='row'>
            <div className='col-12 col-md-6'>
              <ImageList sx={data.imagenes.length === 0 ? {} : { width: 500, height: 450 }} cols={3} rowHeight={164}>
                {data.imagenes.map((item) => (
                  <ImageListItem key={item.id}>
                    <img
                      srcSet={`https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${id}/${item.name} 2x`}
                      src={`https://${import.meta.env.VITE_BUCKET}.s3.us-west-2.amazonaws.com/${configSeller.config.s3.FOLDER_APP}/imagenes/${id}/${item.name}`}
                      alt={item.name}
                      loading='lazy'
                    />
                  </ImageListItem>
                ))}
              </ImageList>
            </div>
            <div className={data.imagenes.length > 0 ? 'col-12 col-md-6' : 'col-12'}>
              {(isSamsungPeru && (ctx.tradein.isBatteryHealthy !== null || ctx.tradein.isExtraControl !== null) && ctx.tradein.id_status === 11) || ctx.tradein.id_status === 3 || isParisChile || (ctx.tradein.id_status === 4 && ctx.displayContract === 0 && (ctx.tradein.isBatteryHealthy !== null || ctx.tradein.isExtraControl !== null))
                ? (
                  <div
                    style={{
                      border: '2px dashed #cccccc',
                      borderRadius: '5px',
                      padding: '20px',
                      textAlign: 'center',
                      backgroundColor: '#ffffff',
                      color: '#000000'
                    }}
                  >
                    <input
                      ref={fileInputRef}
                      type='file'
                      accept='image/png, image/jpg, image/jpeg'
                      id='file-input-multimedia'
                      style={{ display: 'none' }}
                      multiple
                      onChange={handleFileChange}
                    />
                    <Button size='sm' color='warning' onPress={() => fileInputRef.current?.click()}>
                      Seleccionar imágenes
                    </Button>
                    <Typography variant='body2' color='textSecondary' className='mt-2'>
                      (Solo se permiten archivos .png, .jpg y .jpeg)
                    </Typography>
                    <Grid container spacing={2} mt={2}>
                      {ctx.files.map((file, index) => (
                        <Grid item key={index} xs={12} sm={6} md={4}>
                          <Card>
                            <CardContent>
                              <img src={URL.createObjectURL(file)} alt={`preview ${index}`} style={{ width: '100%' }} />
                              <Typography variant='body2'>{file.name}</Typography>
                              <Button color='secondary' size='sm' onClick={(event: any) => removeFile(file, event)}>
                                Eliminar
                              </Button>
                            </CardContent>
                          </Card>
                        </Grid>
                      ))}
                    </Grid>
                  </div>
                  )
                : ctx.tradein.hasFiles === 0 && ctx.displayContract === 1 && !isParisChile
                  ? (
                    <NUIAlert type='info'>Se requiere la firma del contrato para cargar imágenes.</NUIAlert>
                    )
                  : null}
            </div>
          </div>
        </div>

      </CardContent>
      {/* <CardActions style={{ justifyContent: 'flex-end' }}>
        <Button variant='contained' color='success' size='small'>
          Guardar imágenes
        </Button>
      </CardActions> */}
    </Card>
  )
}

export default Multimedia
